module.exports = __webpack_public_path__ + "static/media/pp-white.03cce857.png";